<section class="tax-calendar-swiper-wrapper">
  <div class="calendar">
    <div class="calendar-topic">
      <div class="calendar-topic__heading color-gray"
        ><span>{{ 'TAX_CALENDAR_ACCOUNTING.HEADING' | translate }}</span>
      </div>
      <div class="calendar-topic__heading-detail">
        <span>{{ 'TAX_CALENDAR_ACCOUNTING.DETAIL' | translate }}</span>
      </div>
      <div class="calendar-topic__link">
        <a
          class="hover-underline-text"
          href="https://calendar.google.com/calendar/u/0/r?cid=Y18zZDg1NjYxM2JhNDg4Zjk4ZjFjOWViNDUwYWQyMTQ3MDhmY2VjZmMwZGQxZWZiOTVhNGI3ZTE3YWZiYmRiMTViQGdyb3VwLmNhbGVuZGFyLmdvb2dsZS5jb20"
          rel="noopener noreferrer"
          target="_blank"
        >
          <span>{{ 'TAX_CALENDAR_ACCOUNTING.TEXT_LINK' | translate }}</span></a
        >&nbsp;<i class="fas fa-angle-right"></i>
      </div>
    </div>
    <div class="swiper-container-main">
      <swiper-container class="swiper" appSwiper [config]="config" init="false">
        <ng-container *ngFor="let item of calendarList">
          <swiper-slide class="swiper-slide">
            <div class="box">
              <div
                class="link-color"
                [ngClass]="{
                  'hover-mouse': translate.currentLang === 'th' ? item.data.image.th : item.data.image.en
                }"
                rel="noopener noreferrer"
              >
                <div
                  class="bg-hover"
                  (click)="
                    sharedService.showImage(translate.currentLang === 'th' ? item.data.image.th : item.data.image.en)
                  "
                >
                  <span> {{ 'TAX_CALENDAR_ACCOUNTING.BUTTON' | translate }}</span>
                </div>
                <div class="partner-testimonial-card">
                  <img
                    [src]="translate.currentLang === 'th' ? item.data.image.th : item.data.image.en"
                    loading="lazy"
                    [alt]="translate.currentLang === 'th' ? item.data.alt.th : item.data.alt.en"
                  />
                </div>
              </div>
            </div>
          </swiper-slide>
        </ng-container>
      </swiper-container>

      <div class="swiper-button-prev">
        <i class="fas fa-arrow-left btn__icon"></i>
      </div>
      <div class="swiper-button-next">
        <i class="fas fa-arrow-right btn__icon"></i>
      </div>
    </div>

    <div class="text-explain">*{{ 'TAX_CALENDAR_ACCOUNTING.BUTTON' | translate }}</div>
  </div>
</section>
